import { merge } from 'lodash'
// @mui
import { ThemeOptions } from '@mui/material'
import { createTheme } from '@mui/material/styles'

import componentsOverride from './styles/overrides'
import componentsRaOverride from './styles/ra-overrides'
import palette from './styles/palette'
import typography from './styles/typography'
import shadows from './styles/shadows'
import customShadows from './styles/customShadows'

function ThemeConfig(): ThemeOptions {
  const themeOptions = {
    palette,
    shape: { borderRadius: 6 },
    typography,
    shadows: shadows(),
    customShadows: customShadows(),
  }
  const theme = createTheme(themeOptions)
  theme.components = merge(componentsOverride(theme), componentsRaOverride(theme))
  return theme
}
const theme = ThemeConfig()
export default theme
